import { makeStyles } from 'tss-react/mui';

const useStylesFieldMultiSelect: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  fieldMultiSelect: {
    width: '100%',
    minHeight: 40,
    '& > div': {
      '& > div': {
        whiteSpace: 'normal !important',
        minHeight: '25px !important',
        paddingLeft: 5,
        paddingTop: 7,
        paddingBottom: 7,
      },
      '& > svg': {
        right: 1,
      },
    },
    '& em': {
      display: 'inline-flex',
      margin: 7,
    },
  },
  fieldMultiSelectNoUnderline: {
    '& > div:before, & > div:after': {
      display: 'none',
    },
  },
  fieldMultiSelectBordered: {
    '& > div > div': {
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.palette.info.main}`,
    },
  },
  fieldMultiSelectOutlined: {
    '& > div > div': {
      minHeight: '40px !important',
      padding: 6,
    },
    '& > svg': {
      right: 5,
    },
  },
  fieldMultiSelectItem: {
    display: 'inline-block',
    minHeight: 25,
  },
  fieldMultiSelectItemPlain: {
    minHeight: 25,
  },
  fieldMultiSelectFullWidth: {
    width: '100%',
  },
  fieldTextNewItem: {
    width: 50,
    marginLeft: '10px !important',
    '& > div': {
      minHeight: 'auto',
      '& > input': {
        paddingLeft: 5,
        paddingRight: 5,
        '&:focus': {
          borderBottom: 'none !important',
        },
      },
    },
  },
}));

export default useStylesFieldMultiSelect;
